var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lea-assignment-container"},[_c('h2',[(this.$router.currentRoute.name == 'requests')?_c('lea-display',{attrs:{"lea":_vm.userLea}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }